export default __webpack_public_path__ + "static/green_frog_center-e58148b5668fa972e2d3e7a14f19cdac.png";